import styles from './Hr.module.css';

import React from 'react';

export const Hr = ({ style, margin = true, textBackground = '#fff', children, className }) => {
  return <div className={[styles.main, margin ? styles.margin : '', className].join(' ')} style={style}>
    {children && <span style={{ background: textBackground }}>{children}</span>}
  </div>;
};
